export enum LegalInfoType {
    TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS',
    PRIVACY_POLICY = 'PRIVACY_POLICY',
}
